import React from 'react';

import { usePromoNovosLojistasBanner } from '../../../hooks/usePromoNovosLojistasBanner';
import { useLaunchWindowsBanner } from '../../../hooks/useLaunchWindowsBanner';
import IPVA from '../IPVA';
import LaunchWindowsBanner from '../LaunchWindowsBanner';
import PromoNovosLojistasBanner from '../PromoNovosLojistasBanner';

/**
 * Exibe um único banner na home. Prioridade:
 * 1) Subidas de lotes — sempre que houver config e uma próxima subida (estados 1/2/3);
 * 2) Promo novos lojistas (elegibilidade: cadastro / 1º login / config);
 * 3) IPVA (fallback).
 */
const HomeBanner = () => {
  const launch = useLaunchWindowsBanner();

  const {
    showPromo,
    loading,
    bannerConfig,
    remainingSeconds,
    progress,
  } = usePromoNovosLojistasBanner();

  if (launch.active) {
    return (
      <LaunchWindowsBanner
        state={launch.state}
        referenceLabel={launch.referenceLabel}
        remainingSeconds={launch.remainingSeconds}
      />
    );
  }

  if (loading && !showPromo) {
    return <IPVA />;
  }

  if (showPromo) {
    return (
      <PromoNovosLojistasBanner
        bannerConfig={bannerConfig}
        remainingSeconds={remainingSeconds}
        progress={progress}
      />
    );
  }

  return <IPVA />;
};

export default HomeBanner;
